<div *ngIf="checkAbilitato && abilitato && !loading && faqs && faqs.length > 0" class="w-100 recensioni__wrapper">
    <mat-accordion class="faq__accordion">
        <mat-expansion-panel *ngFor="let faq of faqs">
            <mat-expansion-panel-header class="faqTitolo">
                <mat-panel-title>
                    <h3 class="faqTitle">
                        {{faq.titolo}}
                    </h3>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="faqTesto" [innerHTML]="faq.contenuto"></div>
        </mat-expansion-panel>
    </mat-accordion>
</div>
<app-caricamento *ngIf="loading"></app-caricamento>